// stats.ts — Endpoints statistiques d'usage et synthèses projet.
import { req } from './_internals.js';

export const statsApi = {
  getUsageStats: () => req('GET', '/stats/usage'),
  getIaUsage: () => req('GET', '/stats/ia-usage'),
  getProjectSynthesis: (pid: number | string) =>
    req('GET', '/stats/project-synthesis?project_id=' + encodeURIComponent(String(pid))),
};
